var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeOffArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right 1",
    clipPath: "url(#clip0_170_2296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99057 2.72866C6.49135 2.29684 5.7333 2.34728 5.29692 2.84086C4.86098 3.33487 4.91196 4.08502 5.41074 4.51685L13.9783 11.9349L5.4103 19.3533C4.91108 19.7851 4.86054 20.5353 5.29648 21.0289C5.73286 21.5229 6.49091 21.5733 6.99013 21.1415L16.59 12.829C16.8506 12.6037 17 12.2775 17 11.9349C17 11.5922 16.8506 11.2665 16.59 11.0408L6.99057 2.72866Z",
    fill: "url(#paint0_linear_170_2296)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_2296",
    x1: 16.6296,
    y1: 35.137,
    x2: 2.09544,
    y2: 34.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_2296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.435059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeOffArrow);
export default __webpack_public_path__ + "static/media/orange_off_arrow.c63281191ecb89374c3d04dd24a5f0ab.svg";
export { ForwardRef as ReactComponent };